export const environment = {
  production: false,
  serverUrl: 'https://questionari-api.test.sostenibile.cloud',
  serverGo: 'https://questionari-api.test.go.sostenibile.cloud',
  url: 'https://admin.test.sostenibile.cloud',
  urlGo: 'https://admin.test.go.sostenibile.cloud',
  serverAI: 'https://agent-chat-server.staging.aip.zcscloud.dev',
  folliaUrl: 'https://aip-agents-api.staging.aip.zcscloud.dev',
  dataSourceDefault: '695fd3c6f1b0537d9319c8f2',
};
